// extracted by mini-css-extract-plugin
module.exports = {"cta_button":"WishlistCallToAction_cta_button__LcJYJ","fullyPurchased":"WishlistCallToAction_fullyPurchased__N0W6o","error":"WishlistCallToAction_error__3hLaR"};